import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  editNatMeasure,
  updateRealisationDate,
  updateRealisationNote,
} from "../../../../server/server";

interface EditNoteModalProps {
  open: boolean;
  item: any;
  onClose: () => void;
  onSave: (data: { id: number; note: string; reportId: string }) => void;
}

const EditNoteModal: React.FC<EditNoteModalProps> = ({
  open,
  item,
  onClose,
  onSave,
}) => {
  const [note, setNote] = useState<string>("");

  useEffect(() => {
    if (item) {
      setNote(item.measureNote || item.natMeasureNote || "");
    }
  }, [item]);

  const handleSave = async () => {
    onSave({
      id: item.measureId || item.natMeasureId,
      note,
      reportId: item.id,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Измена напомене : {item?.natMeasureTitle || item?.measureName || "N/A"}
      </DialogTitle>
      <div className="flex justify-start items-start ml-8 mt-3 mr-8">
        <TextField
          label="Напомена"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          sx={{ "& .MuiInputBase-inputMultiline": { padding: "0px 6px" } }}
        />
      </div>

      <div className="flex flex-row justify-between items-center w-full mt-6 px-4 pb-4">
        <div
          className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center border-redError text-redError text-base font-semibold rounded-lg w-[250px] h-[55px]"
          onClick={() => onClose()}
        >
          Oткажи
        </div>
        <div
          className="bg-darkBlue cursor-pointer flex items-center justify-center text-white hover:opacity-90 text-base font-semibold rounded-lg w-[250px] h-[55px]"
          onClick={() => handleSave()}
        >
          Сачувај
        </div>
      </div>
    </Dialog>
  );
};

export default EditNoteModal;
